import { createSlice } from "@reduxjs/toolkit";
import { getUserRoleListThunk } from "tm-shared/api";
import { arrayToRecord } from "tm-shared/utils";

import { DictionariesState } from "./dictionaries.types";

const initialState: DictionariesState = {
    roles: {},
};

export const DictionariesSlice = createSlice({
    name: "dictionaries",
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(
            getUserRoleListThunk.fulfilled,
            (state, { payload }) => {
                state.roles = arrayToRecord(payload.result, "slug");
            },
        );
    },
});

export const dictionariesReducer = DictionariesSlice.reducer;
